import { ContentfulContactBlock } from '@jbhi-fi/apis/src/contentful/types';
import { ContactBlockProps } from '../../ContactBlock';
import { ThemeTransformer } from './ThemeTransformer';

export abstract class ContactBlockTransformer {
  static toContactBlockProps = (
    entry: ContentfulContactBlock,
    options?: { salesLineHours?: string; testId?: string }
  ): ContactBlockProps => {
    return {
      heading: entry.fields?.heading ?? '',
      subText: entry.fields?.subText,
      shouldHideCallUs: entry.fields?.hideCallUs ?? false,
      callText: entry.fields?.callText ?? '',
      callUrl: entry.fields?.callUrl ?? '',
      chatText: entry.fields?.chatText ?? '',
      chatUrl: entry.fields?.chatUrl ?? '',
      margin: entry.fields?.margin ?? 'bottom',
      salesLineHours: options?.salesLineHours,
      testId: options?.testId,
      ...(entry.fields?.themeColourAndIcon?.fields
        ? {
            contentPalette: ThemeTransformer.toContentThemeVariables(entry.fields.themeColourAndIcon).palette,
          }
        : {}),
      disclaimerText: entry.fields?.disclaimerText,
    };
  };
}
